// Task 33: WhatsApp URL helper
// Generated by Windsurf Full-Stack Intelligence — Task 33 v33.0 Unified Quick-Action Layer

const cleanNumber = (phone) => {
  if (!phone) return '';
  // Keep digits only
  const digits = String(phone).replace(/[^0-9]/g, '');
  // If number doesn't start with country code and looks like 10-digit Indian mobile, prefix 91
  if (digits.length === 10) return `91${digits}`;
  return digits;
};

export const getWhatsAppUrl = (phone, message = '') => {
  const target = cleanNumber(phone);
  const encoded = encodeURIComponent(message || 'Hi, this is regarding your application.');
  return `https://wa.me/${target}?text=${encoded}`;
};

export default getWhatsAppUrl;
